import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Box } from 'foundations-components/transitional/components/Box';
import { H1 } from 'foundations-components/transitional/components/H1';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PageHeader = ({
  children,
  title,
  subtitle
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const Header = isMobile ? H2 : H1;
  return /*#__PURE__*/_jsxs(TFlex, {
    gap: 12,
    children: [/*#__PURE__*/_jsxs(Box, {
      grow: 1,
      children: [/*#__PURE__*/_jsx(Header, {
        children: title
      }), /*#__PURE__*/_jsx(Paragraph, {
        children: subtitle
      })]
    }), children]
  });
};